import { VscLoading } from 'react-icons/vsc'

const Loading = () => (
  <div className="loading">
    <VscLoading size={55} strokeWidth={0.5} className="spin" />
  </div>
)

export default Loading
